import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { SuccessDialogComponent } from '../../common/success-dialog/success-dialog.component';
import { DashpillsComponent } from '../../common/dashpills/dashpills.component';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@Component({
  selector: 'app-cv',
  templateUrl: './cv.component.html',
  styleUrls: ['./cv.component.scss']
})
export class CvComponent implements OnInit {
  
  selectedFile: File | null = null;
  fileName: string = '';
  fileTypeError: string = '';
  isUploading: boolean = false;
  userInfo: any;
  hasCv: boolean = false;
  cvUrl: string = ''; // To store the URL of the uploaded CV

  constructor(private apiService: ApiService, private fb: FormBuilder, private dialog: MatDialog) {}

  ngOnInit(): void {
    this.fetchUserInfo();
    this.checkForCv();
  }



  checkForCv(): void {
    this.apiService.checkUserCv().subscribe({
      next: (response) => {
        this.hasCv = response.hasCv;
        if (this.hasCv) {
          this.cvUrl = response.cvUrl; // Save the CV URL if available
          console.log('User has uploaded a CV:', this.cvUrl);
        } else {
          console.log('User has not uploaded a CV');
        }
      },
      error: (error) => console.error('Error checking for CV:', error)
    });
  }


  fetchUserInfo(): void {
    this.apiService.getUserInfo().subscribe({
      next: (info) => {
        this.userInfo = info;
      },
      error: (error) => console.error('Error fetching user info:', error)
    });
  }

  onFileSelected(event: any): void {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      if (file.type === "application/pdf") {
        this.selectedFile = file;
        this.fileName = file.name; // Make sure this line is executed
        console.log('File selected:', this.fileName); // Debugging
      } else {
        alert("Please select a PDF file.");
        this.selectedFile = null;
        this.fileName = ''; // Reset file name if file type is not PDF
      }
    }
  }
  

  uploadCV(): void {
    if (this.selectedFile && this.userInfo?.id) {
      this.isUploading = true;
  
      this.apiService.uploadCV(this.selectedFile, this.userInfo.id).subscribe({
        next: (response) => {
          console.log('Upload successful', response);
          this.isUploading = false;
          this.selectedFile = null;
          this.fileName = '';
          this.hasCv = true; // Update hasCv to true
          // Assuming the response contains the URL or path to the uploaded CV
          this.cvUrl = response.cvUrl; // Update the cvUrl with the new URL/path
          this.dialog.open(SuccessDialogComponent, {
            width: '250px',
            data: { message: 'CV uploaded successfully!' }
          });
        },
        error: (error) => {
          console.error('Error uploading CV:', error);
          this.isUploading = false;
        }
      });
    }
  }
  

}
